module.exports = __webpack_public_path__ + "img/aya shameimaru flower_lw.4a11913f.png";